import { useDispatch } from 'react-redux';

import { enqueueSnackbar } from '../redux/notifier/actions';

export const useCopyToClipboard = (): ((data: string) => Promise<void>) => {
  const dispatch = useDispatch();

  const copy = async (data: string): Promise<void> => {
    try {
      await navigator.clipboard.writeText(data);
      dispatch(
        enqueueSnackbar({
          message: 'copied',
          options: { variant: 'success' },
        })
      );
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
      dispatch(
        enqueueSnackbar({
          message: 'copyFailed',
          options: { variant: 'error' },
        })
      );
    }
  };

  return copy;
};
